// 商品お気に入りボタン
const CUSTOM_PRODUCT_WISHLIST_OPTIMISTIC_DISABLE_MS = 500;

function disableProductWishlistButtonTemporarily(element, duration = CUSTOM_PRODUCT_WISHLIST_OPTIMISTIC_DISABLE_MS) {
  if (!element) return;
  element.disabled = true;
  if (element._multilikesDisableTimer) {
    clearTimeout(element._multilikesDisableTimer);
  }
  element._multilikesDisableTimer = setTimeout(() => {
    element.disabled = false;
    element._multilikesDisableTimer = null;
  }, duration);
}

function parseProductWishlistFavoriteCount(value) {
  if (value === undefined || value === null || value === '') {
    return null;
  }
  const parsed = Number(value);
  return Number.isNaN(parsed) ? null : Math.max(0, parsed);
}

function adjustProductWishlistFavoriteCount(currentCount, wasFavorited, isFavorited) {
  const parsed = parseProductWishlistFavoriteCount(currentCount);
  if (parsed === null || wasFavorited === isFavorited) {
    return parsed;
  }
  return isFavorited ? parsed + 1 : Math.max(0, parsed - 1);
}

const PRODUCT_HEART_SVG = '<svg class="icon-heart" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>';

class ProductWishlistButton {
  constructor(button) {
    this.button = button;
    this.productId = button.dataset.productId || '';
    this.variantId = button.dataset.variantId || '';
    this.customerId = window.multilikesConfig?.customerId || button.dataset.customerId || null;
    this.isInWishlist = button.dataset.isInWishlist === 'true';
    this.defaultUrl = window.multilikesConfig.defaultUrl;
    this.favoriteCount = parseProductWishlistFavoriteCount(button.dataset.favoriteCount) ?? 0;
    this.requestSeq = 0;
    this.pendingRequestCount = 0;
    this.finalSyncTimer = null;
    this.needsFinalSync = false;

    if (this.customerId) {
      this.button.addEventListener('click', () => this.toggleWishlist());
    } else {
      this.button.addEventListener('click', () => this.redirectToLogin());
      this.button.innerHTML = PRODUCT_HEART_SVG;
      this.button.classList.add('add-favorite');
      // 未ログインではお気に入り状態の取得(updateButtonStatus)が走らないため、
      // Liquidが初期表示用に付けた disabled が外れずクリックできない。
      // ゲストの導線はログイン誘導なので、ここで有効化する。
      this.button.disabled = false;
    }
  }

  updateButtonState(isInWishlist, favoriteCount) {
    if (typeof isInWishlist === 'boolean') {
      this.isInWishlist = isInWishlist;
    }

    this.button.dataset.isInWishlist = this.isInWishlist.toString();
    this.button.classList.toggle('is-active', this.isInWishlist);

    if (favoriteCount !== undefined && favoriteCount !== null) {
      if (typeof favoriteCount === 'number' && !Number.isNaN(favoriteCount)) {
        this.favoriteCount = favoriteCount;
      } else {
        this.favoriteCount = parseProductWishlistFavoriteCount(favoriteCount) ?? 0;
      }
    }

    this.button.innerHTML = PRODUCT_HEART_SVG;
    if (this.isInWishlist) {
      this.button.classList.add('remove-favorite');
      this.button.classList.remove('add-favorite');
    } else {
      this.button.classList.add('add-favorite');
      this.button.classList.remove('remove-favorite');
    }

    // Button Wishlist Count
    const wishlistCountTextList = document.querySelectorAll(`[data-multilikes-product-count][data-product-id="${this.productId}"]`);
    if(wishlistCountTextList.length > 0) {
      wishlistCountTextList.forEach(wishlistCountText => {
        const template = 'お気に入り数：[[amount]]件';
        wishlistCountText.textContent = template.replace('[[amount]]', String(this.favoriteCount));
        wishlistCountText.classList.remove('is-loading');
      });
    }
  }

  resolveFavoriteCount(data) {
    if (!data) {
      return null;
    }

    const favoriteCount = data.favoriteCount;
    if (typeof favoriteCount === 'number' && !Number.isNaN(favoriteCount)) {
      return favoriteCount;
    }

    const updatedCount = data.updatedCount;
    if (typeof updatedCount === 'number' && !Number.isNaN(updatedCount)) {
      return updatedCount;
    }

    return null;
  }

  nextRequestSeq() {
    this.requestSeq += 1;
    return this.requestSeq;
  }

  isLatestRequest(seq, productId = this.productId, variantId = this.variantId) {
    return seq === this.requestSeq &&
      productId === this.productId &&
      variantId === this.variantId;
  }

  invalidatePendingResponses() {
    this.requestSeq += 1;
  }

  scheduleFinalSync() {
    if (this.finalSyncTimer) {
      clearTimeout(this.finalSyncTimer);
    }
    this.finalSyncTimer = setTimeout(() => {
      this.finalSyncTimer = null;
      if (this.pendingRequestCount === 0 && this.customerId && this.needsFinalSync) {
        this.needsFinalSync = false;
        ProductWishlistButton.updateButtonStatus(this, { includeFavoriteCount: true, silent: true });
      }
    }, 0);
  }
  
  async toggleWishlist() {
    const previousState = this.isInWishlist;
    const previousCount = this.favoriteCount;
    const nextState = !previousState;
    const action = nextState ? 'add' : 'remove';
    const requestProductId = this.productId;
    const requestVariantId = this.variantId;
    const seq = this.nextRequestSeq();
    this.pendingRequestCount += 1;
    this.updateButtonState(
      nextState,
      adjustProductWishlistFavoriteCount(previousCount, previousState, nextState)
    );
    disableProductWishlistButtonTemporarily(this.button);

    try {
      const response = await fetch(this.defaultUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams({
          'customer_id': this.customerId,
          'product_id': requestProductId,
          'variant_id': requestVariantId,
          'target_type': 'product',
          'action': action
        })
      });

      const data = await response.json();

      if (!this.isLatestRequest(seq, requestProductId, requestVariantId)) {
        this.needsFinalSync = true;
        if (!response.ok) {
          console.error('Stale wishlist update failed:', data);
        }
        return;
      }

      if (response.ok) {
        const payload = data?.data || {};

        const favoriteCount = this.resolveFavoriteCount(payload);
        const resolvedState = typeof payload.isInWishlist === 'boolean'
          ? payload.isInWishlist
          : nextState;
        this.updateButtonState(resolvedState, favoriteCount);

        // コレクションページのお気に入りボタン状態を更新
        const wishlist = payload.wishlist;
        if (Array.isArray(wishlist)) {
          ProductWishlistButton.updateCollectionButtonState(this.productId, wishlist);
        }
      } else {
        throw new Error(data?.error || 'Failed to update wishlist');
      }
    } catch (error) {
      if (this.isLatestRequest(seq, requestProductId, requestVariantId)) {
        this.updateButtonState(previousState, previousCount);
        alert('お気に入りの更新に失敗しました');
      } else {
        this.needsFinalSync = true;
        console.error('Stale wishlist update failed:', error);
      }
    } finally {
      this.pendingRequestCount = Math.max(0, this.pendingRequestCount - 1);
      if (this.pendingRequestCount === 0) {
        this.scheduleFinalSync();
      }
    }
  }

  redirectToLogin() {
    // 未ログインの理由を示してから誘導する。
    // モーダルが無い環境では従来どおりリダイレクトへフォールバックする。
    if (typeof window.requireLoginForWishlist === 'function') {
      window.requireLoginForWishlist();
      return;
    }
    window.location.href = '/account/login?return_url=' + encodeURIComponent(window.location.href);
  }

  /**
   * 静的メソッド：商品お気に入りボタンの初期化
   * @param {HTMLElement} button - 商品お気に入りボタン要素
   * @returns {ProductWishlistButton|null} - 作成されたインスタンス
   */
  static async init(button) {
    if (!button) {
      console.error('Button element is required');
      return null;
    }
    
    const variantId = button.dataset.variantId;
    
    if (!variantId) {
      console.error('Variant ID not found in button');
      return null;
    }
    
    // 新しいインスタンスを作成
    const instance = new ProductWishlistButton(button);
    button._wishlistButtonInstance = instance;


    // 既に初期化済みの場合はスキップ
    if (button.dataset.initialized === 'true') {
      return button._wishlistButtonInstance;
    }

    button.dataset.initialized = 'true';
    
    return instance;
  }

  /**
   * 静的メソッド：すべての商品お気に入りボタンを初期化
   */
  static async initAllButtons() {
    const wishlistButtons = document.querySelectorAll('[data-multilikes-product-button]');
    const initPromises = Array.from(wishlistButtons).map(button => 
      ProductWishlistButton.init(button)
    );
    await Promise.all(initPromises);

    
    wishlistButtons.forEach(button => {
      const variantId = button.dataset.variantId;
      const productId = button.dataset.productId;
      if(variantId && productId) {
        const sectionFormNameElement = document.querySelector('[name="id"][value="' + variantId + '"]');
        if(sectionFormNameElement) {
          const sectionFormElement = sectionFormNameElement.closest('form');
  
          if(sectionFormElement) {
            // 監視だけ登録して return すると updateButtonStatus が呼ばれず、
            // Liquidが付けた disabled が外れないまま(薄いハートで押せない)になる。
            // watchVariantChanges の中の updateButtonData は [name="product-id"] を
            // 必須にしているが、その要素はテーマに存在せず何もしないため。
            ProductWishlistButton.watchVariantChanges(sectionFormElement, button);
          }
        }
      }

      const instance = button._wishlistButtonInstance;
      if (instance?.customerId) {
        ProductWishlistButton.updateButtonStatus(instance, { includeFavoriteCount: true });
      }
    });
  }

  /**
   * 静的メソッド：商品フォームのバリアント変更を監視
   */
  static watchVariantChanges(sectionFormElement, button) {
    const productForm =sectionFormElement;

    if (productForm) {
      const variantSelect = productForm.querySelector('[name="id"]');
      if (variantSelect) {
        let isInitialUpdate = true;
        const handleVariantChange = async () => {
          try {
            await ProductWishlistButton.updateButtonData(button, productForm, {
              includeFavoriteCount: isInitialUpdate,
            });
            isInitialUpdate = false;
          } catch (error) {
            console.error('Error updating wishlist button data:', error);
          }
        };

        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.attributeName === 'value') {
              handleVariantChange();
            }
          });
        });

        observer.observe(variantSelect, {
          attributes: true,
          attributeFilter: ['value']
        });
        
        // 初期状態も更新
        handleVariantChange();
      }
    }
  }

  /**
   * 静的メソッド：ボタンのdata属性を更新
   */
  static async updateButtonData(button, productForm, options = {}) {
    try {
      const productIdSelect = productForm.querySelector('[name="product-id"]');
      const variantIdSelect = productForm.querySelector('[name="id"]');
      
      if (productIdSelect && variantIdSelect) {
        const newProductId = productIdSelect.value;
        const newVariantId = variantIdSelect.value;
        
        // data属性を更新
        button.dataset.productId = newProductId;
        button.dataset.variantId = newVariantId;
        
        // インスタンスのプロパティも更新
        if (button._wishlistButtonInstance) {
          button._wishlistButtonInstance.invalidatePendingResponses();
          button._wishlistButtonInstance.productId = newProductId;
          button._wishlistButtonInstance.variantId = newVariantId;
          
          // 新しいvariantIdのお気に入りステータスを確認してボタンステータスを更新
          await ProductWishlistButton.updateButtonStatus(button._wishlistButtonInstance, options);
        }
      }
    } catch (error) {
      console.error('Error updating button data:', error);
    }
  }

  /**
   * 静的メソッド：コレクションページのお気に入りボタン状態を更新
   * ポップアップ内でお気に入り登録/解除後、対象商品のコレクションボタンのクラスを切り替える
   * @param {string} productId - 商品ID
   * @param {Array<{id: string}>} wishlist - お気に入り一覧（variant ID の配列）
   */
  static updateCollectionButtonState(productId, wishlist) {
    const collectionBtn = document.querySelector(
      `[data-multilikes-collection-button][data-product-id="${productId}"]`
    );
    if (!collectionBtn) return;

    const wishlistIds = new Set(wishlist.map(item => String(item.id)));

    // ポップアップ内の同一商品バリエーションボタンから variant ID を収集
    const variantButtons = document.querySelectorAll(
      `[data-multilikes-product-button][data-product-id="${productId}"]`
    );
    const hasAnyInWishlist = Array.from(variantButtons).some(
      btn => wishlistIds.has(String(btn.dataset.variantId))
    );

    if (hasAnyInWishlist) {
      collectionBtn.classList.add('remove-favorite');
      collectionBtn.classList.remove('add-favorite');
      collectionBtn.classList.add('is-active');
    } else {
      collectionBtn.classList.add('add-favorite');
      collectionBtn.classList.remove('remove-favorite');
      collectionBtn.classList.remove('is-active');
    }
  }

  /**
   * 静的メソッド：ボタンのお気に入りステータスを更新
   */
  static async updateButtonStatus(instance, options = {}) {
    try {
      if (!options.silent) {
        // ローディング状態を設定
        instance.button.disabled = true;
        instance.button.classList.add('is-loading');
      }
      
      const params = new URLSearchParams({
        'customer_id': instance.customerId,
        'target_type': 'product',
        'product_id': instance.productId,
        'variant_id': instance.variantId,
      });
      if (options.includeFavoriteCount === false) {
        params.set('skip_favorite_count', 'true');
      }
      
      const response = await fetch(`${instance.defaultUrl}?${params.toString()}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        }
      });
      
      if (response.ok) {
        const data = await response.json();
        
        if (data.data && data.data.isInWishlist !== undefined) {
          const favoriteCount = instance.resolveFavoriteCount(data.data);
          instance.updateButtonState(data.data.isInWishlist, favoriteCount);
        }
      } else {
        console.error('Failed to check wishlist status for variant:', instance.variantId);
      }
    } catch (error) {
      console.error('Error checking wishlist status for variant:', error);
    } finally {
      if (!options.silent) {
        // ローディング状態を解除
        instance.button.disabled = false;
        instance.button.classList.remove('is-loading');
      }
    }
  }
}

// ページのリロード時にページ上のボタンを初期化
/**
 * バリエーション変更にお気に入りボタンを追従させる。
 *
 * 既存の watchVariantChanges は複数バリエーション商品では機能しない:
 *   - 登録条件の `[name="id"][value="…"]` は、複数バリエーション時に出力される
 *     <select name="id">(value属性なし)にマッチしない
 *   - updateButtonData が必須にしている [name="product-id"] はテーマ内に存在しない
 *   - observer は <select> の value 属性を監視するが、theme.js は <option> の
 *     selected を付け替えるだけなので発火しない
 *
 * そのため theme.js が section 要素に bubbles で dispatch している
 * 'variant:changed' を購読して、ボタンの variantId を直接更新する。
 */
function followVariantChangeForWishlist() {
  document.addEventListener('variant:changed', (event) => {
    const variant = event.detail && event.detail.variant;
    if (!variant || !variant.id) return;

    // 画面下の固定バー(.c-variant-btn-wrapper)は </section> より後に出力されるため、
    // dispatch 元の section 配下だけを見ると対象から漏れる。
    // SPではその固定バーが唯一のお気に入り導線になるので document 全体から探し、
    // 商品IDで自商品のボタンだけに絞る。
    const section = event.target.closest('[data-section-type="product"]');
    const reference = section && section.querySelector('[data-multilikes-product-button]');
    const productId = reference ? reference.dataset.productId : null;
    const buttons = document.querySelectorAll('[data-multilikes-product-button]');

    buttons.forEach((button) => {
      // アート版ポップアップのボタンは variant ごとに描画済みなので触らない
      if (button.closest('.c-variant-popup')) return;
      // 他商品(関連商品ブロック等)のボタンは対象外
      if (productId && button.dataset.productId !== productId) return;

      const newVariantId = String(variant.id);
      if (button.dataset.variantId === newVariantId) return;
      button.dataset.variantId = newVariantId;

      const instance = button._wishlistButtonInstance;
      if (!instance) return;

      instance.invalidatePendingResponses?.();
      instance.variantId = newVariantId;
      // 未ログインでは取得する状態が無いのでリクエストしない
      if (!instance.customerId) return;
      ProductWishlistButton.updateButtonStatus(instance, { includeFavoriteCount: true });
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  ProductWishlistButton.initAllButtons();
  followVariantChangeForWishlist();
});

// グローバル関数として公開
window.initProductWishlist = function() {
  ProductWishlistButton.initAllButtons();
};
